import { copyText } from '@elem/ui-common/utils/copyText';
import EfLink from '@elem/ui/ef-link';
import EfMessage, { EfMessageGlobal } from 'elem/ui/ef-message';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import IconClose from '../../icons/IconClose';
import IconCopy from './IconCopy';
import './index.scss';

export default function WinTipsSuccessA({ couponData = {}, TextA = {}, callback }: { couponData?: any; TextA?: any; callback?: any }) {
    const refDialog = useRef<any>(null);
    const { locale = 'us' } = useRouter();
    const closeHandle = () => {
        callback && callback();
    };
    useEffect(() => {
        refDialog.current.showModal();
    }, []);
    const coupon = couponData?.coupon;
    const shoppingUrl = couponData?.shoppingUrl;
    // 复制
    const copyHandle = () => {
        copyText(coupon);
        EfMessage.success(TextA.copy_success1);
    };
    const gtm_shopify = {
        event: 'uaEvent',
        event_name: 'buy',
        product_name: 'none',
        position: `Check in_${TextA.ShopNow}`,
    };
    const gtm_website = {
        event: 'uaEvent',
        event_name: 'select_product',
        list_name: 'Check in',
        product_name: 'none',
        button_name: TextA.ShopNow,
    };
    const gtm_dataLayer = (shoppingUrl || '').includes('www.ecoflow.com') ? gtm_website : gtm_shopify;
    return (
        <dialog className="ef-check-in-dialog ef-check-in-dialog-common ef-check-in-dialog-WinTipsSuccessA" ref={refDialog}>
            <div className="ef-check-in-dialog-wrap">
                <div className="ef-check-in-dialog-body">
                    <div className="ef-check-in-dialog-title">{TextA.successSortC}</div>
                    <div className="ef-check-in-dialog-content">
                        <div className="ef-check-in-dialog-content-line1">
                            {TextA.couponTipsC1}
                            {couponData?.couponName}
                            {TextA.couponTipsC2}
                        </div>
                        {coupon && (
                            <div className="ef-check-in-dialog-content-line2" onClick={copyHandle}>
                                {couponData?.coupon}
                                <IconCopy />
                            </div>
                        )}
                    </div>
                    {shoppingUrl && (
                        <div className="ef-check-in-dialog-footer">
                            <EfLink href={shoppingUrl} className="ef-check-in-dialog-btn" dataLayer={gtm_dataLayer}>
                                {TextA.ShopNow}
                            </EfLink>
                        </div>
                    )}
                    <button className="ef-check-in-dialog-close" onClick={closeHandle}>
                        <IconClose />
                    </button>
                </div>
            </div>
            <EfMessageGlobal />
        </dialog>
    );
}
